import React from "react";

import DateInput from "./DateInput";
import {
  FnrDateInput2Provider,
  useFnrDateInput2,
} from "./FnrDatePicker2Context";

export default function FnrDateInput2({
  placeholder,
  style,
  setDate,
  initialDate,
  focusColor,
  killHoverStyles = false,
  includeYear = true,
  clearDateId,
  preventDefault,
  noWrap,
  className,
  showSave,
  onSave,
  isLoading,
  backgroundColor,
}) {
  return (
    <FnrDateInput2Provider setDate={setDate} initialDate={initialDate}>
      <DateInput
        placeholder={placeholder}
        style={style}
        focusColor={focusColor}
        killHoverStyles={killHoverStyles}
        includeYear={includeYear}
        clearDateId={clearDateId}
        preventDefault={preventDefault}
        noWrap={noWrap}
        className={className}
        showSave={showSave}
        onSave={onSave}
        isLoading={isLoading}
        backgroundColor={backgroundColor}
      />
    </FnrDateInput2Provider>
  );
}
